import { tauriInvoke } from '../services/desktopIntegration';

export interface SecureFetchOptions {
  url: string;
  method?: string;
  headers?: Record<string, string>;
  data?: any;
}

export async function secureFetch({
  url,
  method = 'GET',
  headers = {},
  data = null,
}: SecureFetchOptions): Promise<any> {
  const body = data ? JSON.stringify(data) : null;

  try {
    const response: any = await tauriInvoke('secure_fetch', {
      params: {
        url,
        method,
        headers,
        body,
      },
    });

    const mimickedResponse = {
      status: response.status, // Status code (e.g., 200, 404, etc.)
      headers: response.headers || {}, // Headers of the response
      body: response.body, // Body of the response
      json: async () => JSON.parse(response.body), // Mimic response.json() method
      text: async () => response.body, // Mimic response.text() method
      ok: response.status >= 200 && response.status < 300, // Simulate .ok property
    };

    console.log(
      `SKINNER: secureFetch ${url} ${method} ${JSON.stringify(headers)} ${JSON.stringify(data)} ${JSON.stringify(
        mimickedResponse
      )}`
    );

    return mimickedResponse;
  } catch (error) {
    console.error('secureFetch error:', error);
    throw error;
  }
}
